<div *ngIf="paginationData" class="d-flex gap-2 justify-content-between align-items-center">
  <div class="d-flex gap-1 align-items-center">
    <form class="" *ngIf="hasPerPageSelector">
      <select
        style="cursor: pointer"
        class="form-control form-select-sm bg-transparent border-0 form-select"
        name="itemsPerPage"
        [(ngModel)]="itemsPerPage"
        (change)="changeItemsPerPage(itemsPerPage)"
      >
        <option *ngFor="let option of perPageOptions" [value]="option">
          {{ option }}
        </option>
      </select>
    </form>
    <p class="mb-0">
      {{ currentPage * itemsPerPage + 1 }}
      <span class="text-muted"> à </span>
      {{ currentPage * itemsPerPage + paginationData.numberOfElements }}
      <span class="text-muted">sur</span>
      {{ paginationData.totalElements }}
    </p>
  </div>
  <p class="mb-0">
    <!-- Start First Page Link -->
    <span *ngIf="paginationData.first; else firstPageLink" class="me-2 text-muted"> << </span>
    <ng-template #firstPageLink>
      <a
        style="cursor: pointer"
        (click)="goToPage(0)"
        [ngClass]="paginationData.first ? 'disabled' : ''"
        class="me-2"
      >
        <<
      </a>
    </ng-template>
    <!-- End First Page Link -->

    <!-- Start Previous Page Link -->
    <span *ngIf="paginationData.first; else previousPageLink" class="me-2 text-muted"> < </span>
    <ng-template #previousPageLink>
      <a
        style="cursor: pointer"
        (click)="goToPage(currentPage - 1)"
        class="me-2"
        [ngClass]="paginationData.first ? 'disabled' : ''"
      >
        <
      </a>
    </ng-template>
    <!-- End Previous Page Link -->

    <!-- Current Page Indicator -->
    page <span class="text-dark">{{ currentPage + 1 }}</span> sur
    {{ paginationData.totalPages }}
    <!-- End Current Page Indicator -->

    <!-- Start Next Page Link -->
    <span *ngIf="paginationData.last; else nextPageLink" class="ms-2 text-muted"> > </span>
    <ng-template #nextPageLink>
      <a
        style="cursor: pointer"
        (click)="goToPage(currentPage + 1)"
        class="ms-2"
        [ngClass]="paginationData.last ? 'disabled' : ''"
      >
        >
      </a>
    </ng-template>
    <!-- End Next Page Link -->

    <!-- Start Last Page Link -->
    <span *ngIf="paginationData.last; else lastPageLink" class="ms-2 text-muted"> >> </span>
    <ng-template #lastPageLink>
      <a
        style="cursor: pointer"
        (click)="goToPage(paginationData.totalPages - 1)"
        class="ms-2"
        [ngClass]="paginationData.last ? 'disabled' : ''"
      >
        >>
      </a>
    </ng-template>
    <!-- End Last Page Link -->
  </p>
</div>
